// extracted by mini-css-extract-plugin
export default {"cell":"SubCategoriesSlider_cell__I+qzy","categories":"SubCategoriesSlider_categories__frN8B","item":"SubCategoriesSlider_item__kvJHY","button":"SubCategoriesSlider_button__qekVk"};